import { is } from 'ramda'
import { fetchContext } from '../rag';

const gptToken = "sk-proj-zb780XlrIiVfCSrhI10WT3BlbkFJcVWUmV5FjFN33uVSiJ7c";
export const defaultAssistantId = "asst_rZgDhtjLMGFmwrsiu5nTdfWc";

export async function createThread(organizationMetadata, assistantId) {
    const myHeaders = new Headers();
    myHeaders.append("OpenAI-Beta", "assistants=v2");
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${gptToken}`);

    const requestOptions = {
        method: "POST",
        headers: myHeaders,
        redirect: "follow"
    };

    const response = await fetch("https://api.openai.com/v1/threads", requestOptions);
    const responseJSON = await response.json();
    const threadId = responseJSON.id;

    // pass initial organization metadata
    if (organizationMetadata) {
        const metadataAwerenessPrompt = `Please, consider this metadata JSON about our organization in following conversation: ${JSON.stringify(organizationMetadata)}`;
        await sendMessageToThread({
            message: metadataAwerenessPrompt,
            threadId,
            assistantId
        });
    }
    return threadId;
}

export async function sendMessageToThread({ message, threadId, organizationId, assistantId }) {
    let ragContext = '';
    let messageToSend = message;

    if (organizationId) {
        ragContext = await fetchContext(organizationId, message);
        if (ragContext) {
            messageToSend = messageToSend + `\n Additionally, use the provided context to inform your response: "${ragContext}".`;
        }
    }

    const myHeaders = new Headers();
    myHeaders.append("OpenAI-Beta", "assistants=v2");
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${gptToken}`);

    console.log(`[DEBUG] propmpt:`, messageToSend);

    const raw = JSON.stringify({
        "assistant_id": assistantId,
        "stream": true,
        "additional_messages": [
            {
                "role": "user",
                "content": messageToSend
            },
        ]
    });

    const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow"
    };

    const response = await fetch(`https://api.openai.com/v1/threads/${threadId}/runs`, requestOptions);
    const stream = response.body;
    const reader = stream.getReader();

    const readChunk = async () => {
        const { value, done } = await reader.read();
        if (done) {
            console.log('Stream finished');
            return;
        }

        // const chunkString = new TextDecoder().decode(value);
        // const { event, data } = parseChunkString(chunkString);

        // if (event !== "thread.message.delta") {
        //     console.log('[DEBUG] ChatGPT chunk:', { event, data });
        // }
        
        // if (event === 'thread.message.completed') {
        //     console.log('[DEBUG] ChatGPT chunk thread.message.completed chunkString"', chunkString);
        //     return data.content[0].text.value;
        // }

        // if (event === 'thread.run.failed') {
        //     return data.last_error.message;
        // }
        
        return await readChunk();
    };

    await readChunk();

    // get last message
    return await fetchLastMessage(threadId);
}

export class Message {
    constructor(message = {}) {
        this.id = is(String, message.id) ? message.id : ''
        this.text = is(String, message.text) ? message.text : ''
        this.time = is(String, message.time) ? message.time : ''
        this.userId = is(Number, message.userId) ? message.userId : ''
        this.me = is(Boolean, message.me) ? message.me : false
        this.created_at = is(Number, message.created_at) ? message.created_at : 0
    }
}

function parseChunkString(input) {
    // Split the input into lines
    const lines = input.split('\n');

    // Initialize variables for event and data
    let event = '';
    let data = '';

    // Iterate over each line
    for (let line of lines) {
        // Check if the line starts with 'event:'
        if (line.startsWith('event:')) {
            event = line.slice('event:'.length).trim();
        }
        // Check if the line starts with 'data:'
        else if (line.startsWith('data:')) {
            data = line.slice('data:'.length).trim();
        }
    }

    // Parse data as JSON
    let dataJSON;
    try {
        dataJSON = JSON.parse(data);
    } catch (error) {
        console.error('Failed to parse data as JSON', error);
        return { event, data: null };
    }

    // Return the event and data JSON
    return { event, data: dataJSON };
}

function escapeHTML(str) {
    return str.replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");
}


export function convertToHTML(str) {
    // Escape HTML characters
    str = escapeHTML(str);

    // Convert headers
    str = str.replace(/^###### (.*$)/gim, '<h6>$1</h6>');
    str = str.replace(/^##### (.*$)/gim, '<h5>$1</h5>');
    str = str.replace(/^#### (.*$)/gim, '<h4>$1</h4>');
    str = str.replace(/^### (.*$)/gim, '<h3>$1</h3>');
    str = str.replace(/^## (.*$)/gim, '<h2>$1</h2>');
    str = str.replace(/^# (.*$)/gim, '<h1>$1</h1>');

    // Convert bold and italics
    str = str.replace(/\*\*\*(.*?)\*\*\*/gim, '<em><strong>$1</strong></em>');
    str = str.replace(/\*\*(.*?)\*\*/gim, '<strong>$1</strong>');
    str = str.replace(/\*(.*?)\*/gim, '<em>$1</em>');

    // Convert strikethrough
    str = str.replace(/~~(.*?)~~/gim, '<del>$1</del>');

    // Convert links
    str = str.replace(/\[([^\]]+)\]\(([^)]+)\)/gim, '<a href="$2">$1</a>');

    // Convert unordered lists
    str = str.replace(/^\s*[-+*]\s+(.*$)/gim, '<ul><li>$1</li></ul>');

    // Convert ordered lists
    str = str.replace(/^\s*\d+\.\s+(.*$)/gim, '<ol><li>$1</li></ol>');

    // Convert blockquotes
    str = str.replace(/^\>\s+(.*$)/gim, '<blockquote>$1</blockquote>');

    // Convert inline code
    str = str.replace(/`(.*?)`/gim, '<code>$1</code>');

    // Convert newlines to <br>
    str = str.replace(/\n/g, '<br>');

    return str;
}

async function fetchLastMessage(threadId) {
    const myHeaders = new Headers();
    myHeaders.append("OpenAI-Beta", "assistants=v2");
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${gptToken}`);

    const requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow"
    };

    const response = await fetch(`https://api.openai.com/v1/threads/${threadId}/messages`, requestOptions);
    const responseJSON = await response.json();
    const {first_id, data} = responseJSON;
    const message = data.find(i => i.id === first_id);
    if (!message) {
        throw new Error(`failed to find message '${first_id}'`)
    }
    return message.content[0].text.value;
}
